import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

const routes = [{
  path: "/",
  name: "index",
  component: () => import("../views/index.vue"),
  meta: {
    title: '智慧优选',
    active: '首页',
    keepAlive: true,
  }
}, {
  path: '/result',
  name: 'result',
  component: () => import("../views/result.vue"),
  meta: {
    title: '推荐搜索',
    keepAlive: false
  }
}, {
  path: '/detail',
  name: 'detail',
  component: () => import("../views/detail.vue"),
  meta: {
    title: '商品详情',
    touFlag: true
  }
}, {
  path: '/order',
  name: 'order',
  component: () => import("../views/order.vue"),
  meta: {
    title: '确认订单'
  }
}, {
  path: '/addressList',
  name: 'addressList',
  component: () => import("../views/addressList.vue"),
  meta: {
    title: '收货地址'
  }
}, {
  path: '/address',
  name: 'address',
  component: () => import("../views/address.vue"),
  meta: {
    title: '收货信息'
  }
}, {
  path: '/pay_result',
  name: 'pay_result',
  component: () => import("../views/pay_result.vue"),
  meta: {
    title: '支付成功'
  }
}, {
  path: '/myorder',
  name: 'myorder',
  component: () => import("../views/myorder.vue"),
  meta: {
    title: '我的订单',
    active: '我的'
  }
}, {
  path: '/alert',
  name: 'alert',
  component: () => import("../views/alert.vue"),
  meta: {
    title: '跳转中...'
  }
}];

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes,

});



export default router;